export enum CLPatientInfoTabsEnum {
    CALORIES_RECORD = 0,
    MESSAGE_DELIVERY = 1,
}

export enum CLMessageTypeEnum {
    MEDICAL_GUIDE = 'MEDICAL_GUIDE',
    CALORIE_MANAGEMENT = 'CALORIE_MANAGEMENT',
    ETC = 'ETC',
}
